import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Reveal from "../components/Reveal";
import RevealImage from "../components/RevealImage";
import { projects } from "../data/projects";

export default function Works() {
  return (
    <>
      <Seo
        title="Works"
        description="Selected architectural works by RM.NM Architects — residences, institutional and cultural projects across Gujarat, India."
      />

      <section className="container-page pt-16 md:pt-24 pb-12 md:pb-20">
        <Reveal>
          <div className="eyebrow mb-6">Selected Works</div>
          <h1 className="font-display text-[2.5rem] sm:text-6xl md:text-8xl tracking-wider sm:tracking-widest2 leading-[0.95]">
            Projects
          </h1>
          <p className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed text-smoke">
            A selection of recent and ongoing work. Each project responds to its specific climate,
            culture and client — residences gathered around courtyards, institutions in quiet
            dialogue with their context.
          </p>
        </Reveal>
      </section>

      <section className="container-page pb-24 md:pb-40">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 md:gap-x-10 gap-y-16 md:gap-y-24">
          {projects.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 2) * 0.1}>
              <Link to={`/works/${p.slug}`} className="group block">
                <RevealImage
                  aspect={i % 2 === 0 ? "aspect-[4/5]" : "aspect-[3/4]"}
                  className={i % 2 === 0 ? "" : "md:mt-16"}
                  delay={i * 0.08}
                >
                  <img
                    src={`/images/${p.slug}/full/${p.cover}.jpg`}
                    alt={p.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-smooth group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/10 transition-colors duration-500" />
                  <div className="absolute top-4 left-4 text-[11px] tracking-widest3 uppercase text-paper z-[11]">
                    0{i + 1}
                  </div>
                </RevealImage>
                <div className="mt-6 flex items-baseline justify-between gap-6">
                  <div>
                    <h2 className="font-display text-3xl md:text-4xl tracking-widest2">
                      {p.title}
                    </h2>
                    <div className="mt-2 text-xs tracking-widest2 uppercase text-smoke">
                      {p.typology} — {p.location}
                    </div>
                  </div>
                  <span className="hidden md:inline text-xs tracking-widest2 uppercase text-smoke group-hover:text-ink transition-colors">
                    View →
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
